import StorageGroup from './StorageGroup'
export default StorageGroup
